/**
 * TanStack Router: /vacation/approvals
 *
 * This route file was auto-generated by the route generation script.
 * Component: VacationApprovalsPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import VacationApprovalsPage from '@/app/vacation/approvals/page'

/**
 * Route: /vacation/approvals
 * Layout: _auth (authenticated)
 * Component: VacationApprovalsPage
 */
export const Route = createFileRoute('/_auth/vacation/approvals')({
  component: VacationApprovalsPage,
})
